export default {
  layout: {
    search: 'Search',
    tabs: {
      all: 'All',
      private: 'Private Messages',
      group: 'Group Chats'
    },
    user: {
      info: 'User Info',
      online: 'Online',
      lastLogin: 'Last Login',
      email: 'Email'
    },
    material: {
      library: 'Material Library',
      image: {
        title: 'Material1.png'
      },
      document: {
        title: 'Report.docx'
      },
      video: {
        title: 'Demo Video.mp4'
      },
      audio: {
        title: 'Audio File.mp3'
      }
    }
  }
}
